import { faStar } from '@fortawesome/free-solid-svg-icons'
import Badge from '../common/badge/Badge'
import { BadgeColor } from '../common/badge/badgeTypes'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

interface Props {
    pluralized?: boolean
}

export function HelixSearchV2TopPickBadge({ pluralized = false }: Props) {
    return (
        <Badge color={BadgeColor.TopPickYellow}>
            <FontAwesomeIcon icon={faStar} className="mr-1" />
            <span className="font-bold">TOP PICK{pluralized ? 'S' : ''}</span>
        </Badge>
    )
}
